/**
 * Full-collection date sorting using custom.activated_at (fallback: created_at).
 * Liquid can only see 50 products per page, so recently activated older products
 * would otherwise stay stuck on later Shopify pages. This script loads every
 * page of a stable feed, sorts by effective date, then renders the current page.
 */
(function () {
  if (window.themeActivationSort) return;

  var VIEW = "activation-sort-data";
  var ENUM_SORT = "title-ascending";
  var cache = {};

  function getParams() {
    return new URLSearchParams(window.location.search);
  }

  function getSortBy(root) {
    return getParams().get("sort_by") || (root && root.getAttribute("data-default-sort")) || "";
  }

  function isDateSort(sortBy) {
    return sortBy === "created-descending" || sortBy === "created-ascending";
  }

  function cacheKey(path, params) {
    var copy = new URLSearchParams(params.toString());
    copy.delete("page");
    copy.delete("view");
    copy.delete("sort_by");
    return path + "?" + copy.toString();
  }

  function buildFeedUrl(path, params, page) {
    var copy = new URLSearchParams(params.toString());
    copy.delete("page");
    // Enumerate with a stable sort so every product appears on exactly one page.
    copy.set("sort_by", ENUM_SORT);
    copy.set("view", VIEW);
    copy.set("page", String(page));
    return path + "?" + copy.toString();
  }

  function parseFeed(text) {
    var trimmed = text.trim();
    // Guard against accidental HTML wrappers
    var start = trimmed.indexOf("{");
    var end = trimmed.lastIndexOf("}");
    if (start === -1 || end === -1) {
      throw new Error("Activation sort feed was not JSON");
    }
    return JSON.parse(trimmed.slice(start, end + 1));
  }

  function fetchFeed(url) {
    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      if (!response.ok) throw new Error("Failed to load " + url);
      return response.text().then(parseFeed);
    });
  }

  function loadAllProducts(path, params) {
    var key = cacheKey(path, params);
    if (cache[key]) return Promise.resolve(cache[key]);

    return fetchFeed(buildFeedUrl(path, params, 1)).then(function (first) {
      var pages = first.pages || 1;
      var products = first.products.slice();
      var fetches = [];

      for (var page = 2; page <= pages; page++) {
        fetches.push(fetchFeed(buildFeedUrl(path, params, page)));
      }

      return Promise.all(fetches).then(function (rest) {
        rest.forEach(function (feed) {
          products = products.concat(feed.products || []);
        });

        // Deduplicate by handle in case of overlapping pages
        var seen = {};
        var unique = [];
        products.forEach(function (product) {
          if (!product || !product.handle || seen[product.handle]) return;
          seen[product.handle] = true;
          product.ts = parseInt(product.ts, 10) || 0;
          unique.push(product);
        });

        cache[key] = unique;
        return unique;
      });
    });
  }

  function renderGrid(grid, products) {
    grid.innerHTML = products
      .map(function (product) {
        return product.html || "";
      })
      .join("");

    if (window.theme && typeof theme.reinitProductGridItem === "function") {
      theme.reinitProductGridItem();
    }
  }

  function applyCollectionSort() {
    var root = document.querySelector("[data-activation-sort]");
    if (!root) return Promise.resolve();

    var sortBy = getSortBy(root);
    if (!isDateSort(sortBy)) {
      root.removeAttribute("data-activation-sort-loading");
      return Promise.resolve();
    }

    var grid = document.querySelector(
      "#CollectionAjaxContent .collection-grid__wrapper .grid.grid--uniform"
    );
    if (!grid) return Promise.resolve();

    var path = window.location.pathname;
    var params = getParams();
    // CMS page size = per_row × rows_per_page (capped at 50 in Liquid)
    var pageSize = parseInt(root.getAttribute("data-page-size"), 10) || 20;
    var productLimit = parseInt(root.getAttribute("data-product-limit"), 10) || 0;
    var page = parseInt(params.get("page"), 10) || 1;
    var descending = sortBy === "created-descending";

    root.setAttribute("data-activation-sort-loading", "");

    return loadAllProducts(path, params)
      .then(function (products) {
        var sorted = products.slice().sort(function (a, b) {
          if (a.ts === b.ts) {
            return a.handle < b.handle ? -1 : 1;
          }
          return descending ? b.ts - a.ts : a.ts - b.ts;
        });

        // CMS "Maximum products to show" (e.g. New Arrivals = 10):
        // keep global newest-first order, but only render that many items.
        if (productLimit > 0) {
          renderGrid(grid, sorted.slice(0, productLimit));
          return;
        }

        var start = (page - 1) * pageSize;
        renderGrid(grid, sorted.slice(start, start + pageSize));
      })
      .catch(function (error) {
        console.warn("[activation-sort]", error);
      })
      .finally(function () {
        root.removeAttribute("data-activation-sort-loading");
      });
  }

  function applyRecentProductsSort() {
    var root = document.querySelector("[data-activation-sort-recent]");
    if (!root) return Promise.resolve();

    var grid = root.querySelector(".grid.grid--uniform");
    if (!grid) return Promise.resolve();

    var limit = parseInt(root.getAttribute("data-product-limit"), 10) || 4;
    var path = root.getAttribute("data-collection-url") || "/collections/all";
    var params = new URLSearchParams();

    return loadAllProducts(path, params)
      .then(function (products) {
        var sorted = products.slice().sort(function (a, b) {
          if (a.ts === b.ts) {
            return a.handle < b.handle ? -1 : 1;
          }
          return b.ts - a.ts;
        });
        renderGrid(grid, sorted.slice(0, limit));
      })
      .catch(function (error) {
        console.warn("[activation-sort-recent]", error);
      });
  }

  function init() {
    applyCollectionSort();
    applyRecentProductsSort();
  }

  window.themeActivationSort = {
    init: init,
    applyCollectionSort: applyCollectionSort,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("collection:reloaded", function () {
    var root = document.querySelector("[data-activation-sort]");
    if (root && isDateSort(getSortBy(root))) {
      root.setAttribute("data-activation-sort-loading", "");
    }
    applyCollectionSort();
  });
})();
